import { render } from "./GovContractPage.vue?vue&type=template&id=6b242a18&scoped=true"
const script = {}

import "./GovContractPage.vue?vue&type=style&index=0&id=6b242a18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b242a18"]])

export default __exports__